// Mock data for Prop Indexa Platform

export const accountPlans = {
  instant: [
    {
      id: 'instant-5k',
      capital: 5000,
      price: 45,
      profitSplit: '80%',
      maxDrawdown: '5%',
      maxDrawdownAmount: 250,
      dailyDrawdown: '3%',
      dailyDrawdownAmount: 150,
      minTradingDays: 0,
      maxOpenRisk: '1%',
      payoutFrequency: '10 days',
      leverage: '1:1000',
      consistencyRule: '25%',
      popular: false
    },
    {
      id: 'instant-10k',
      capital: 10000,
      price: 75,
      profitSplit: '80%',
      maxDrawdown: '5%',
      maxDrawdownAmount: 500,
      dailyDrawdown: '3%',
      dailyDrawdownAmount: 300,
      minTradingDays: 0,
      maxOpenRisk: '1%',
      payoutFrequency: '10 days',
      leverage: '1:1000',
      consistencyRule: '25%',
      popular: true
    },
    {
      id: 'instant-25k',
      capital: 25000,
      price: 185,
      profitSplit: '80%',
      maxDrawdown: '5%',
      maxDrawdownAmount: 1250,
      dailyDrawdown: '3%',
      dailyDrawdownAmount: 750,
      minTradingDays: 0,
      maxOpenRisk: '1%',
      payoutFrequency: '10 days',
      leverage: '1:1000',
      consistencyRule: '25%',
      popular: false
    },
    {
      id: 'instant-50k',
      capital: 50000,
      price: 375,
      profitSplit: '80%',
      maxDrawdown: '5%',
      maxDrawdownAmount: 2500,
      dailyDrawdown: '3%',
      dailyDrawdownAmount: 1500,
      minTradingDays: 0,
      maxOpenRisk: '1%',
      payoutFrequency: '10 days',
      leverage: '1:1000',
      consistencyRule: '25%',
      popular: false
    }
  ],
  oneStep: [
    {
      id: 'onestep-5k',
      capital: 5000,
      price: 39,
      profitSplit: '80%',
      maxDrawdown: '8%',
      maxDrawdownAmount: 400,
      dailyDrawdown: '5%',
      dailyDrawdownAmount: 250,
      minTradingDays: 'Optional',
      profitTarget: '10%',
      profitTargetAmount: 500,
      maxOpenRisk: '1%',
      payoutFrequency: '10 days',
      leverage: '1:1000',
      consistencyRule: false,
      popular: false
    },
    {
      id: 'onestep-10k',
      capital: 10000,
      price: 69,
      profitSplit: '80%',
      maxDrawdown: '8%',
      maxDrawdownAmount: 800,
      dailyDrawdown: '5%',
      dailyDrawdownAmount: 500,
      minTradingDays: 'Optional',
      profitTarget: '10%',
      profitTargetAmount: 1000,
      maxOpenRisk: '1%',
      payoutFrequency: '10 days',
      leverage: '1:1000',
      consistencyRule: false,
      popular: true
    },
    {
      id: 'onestep-25k',
      capital: 25000,
      price: 169,
      profitSplit: '80%',
      maxDrawdown: '8%',
      maxDrawdownAmount: 2000,
      dailyDrawdown: '5%',
      dailyDrawdownAmount: 1250,
      minTradingDays: 'Optional',
      profitTarget: '10%',
      profitTargetAmount: 2500,
      maxOpenRisk: '1%',
      payoutFrequency: '10 days',
      leverage: '1:1000',
      consistencyRule: false,
      popular: false
    },
    {
      id: 'onestep-50k',
      capital: 50000,
      price: 299,
      profitSplit: '80%',
      maxDrawdown: '8%',
      maxDrawdownAmount: 4000,
      dailyDrawdown: '5%',
      dailyDrawdownAmount: 2500,
      minTradingDays: 'Optional',
      profitTarget: '10%',
      profitTargetAmount: 5000,
      maxOpenRisk: '1%',
      payoutFrequency: '10 days',
      leverage: '1:1000',
      consistencyRule: false,
      popular: false
    }
  ]
};

export const tradingRules = {
  instant: [
    {
      id: 1,
      title: 'Daily Drawdown',
      description: '3% equity-based daily drawdown limit',
      icon: 'TrendingDown'
    },
    {
      id: 2,
      title: 'Maximum Drawdown',
      description: '5% maximum overall drawdown (equity-based)',
      icon: 'AlertTriangle'
    },
    {
      id: 3,
      title: 'Max Open Risk',
      description: '1% maximum open risk per trade',
      icon: 'Shield'
    },
    {
      id: 4,
      title: 'Profit Consistency',
      description: 'No single trading day can contribute more than 25% of total profit at withdrawal',
      icon: 'BarChart3'
    },
    {
      id: 5,
      title: 'Payout Cycle',
      description: 'Request withdrawals every 10 days with 80% profit split',
      icon: 'Calendar'
    },
    {
      id: 6,
      title: 'Leverage & Instruments',
      description: '1:1000 leverage on Synthetic Indices - 24/7 trading available',
      icon: 'Zap'
    }
  ],
  oneStep: [
    {
      id: 1,
      title: 'Profit Target',
      description: '10% profit target during evaluation phase',
      icon: 'Target'
    },
    {
      id: 2,
      title: 'Daily Drawdown',
      description: '5% equity-based daily drawdown limit',
      icon: 'TrendingDown'
    },
    {
      id: 3,
      title: 'Maximum Drawdown',
      description: '8% overall drawdown limit (equity-based)',
      icon: 'AlertTriangle'
    },
    {
      id: 4,
      title: 'Max Open Risk',
      description: '1% maximum open risk per trade',
      icon: 'Shield'
    },
    {
      id: 5,
      title: 'Minimum Trading Days',
      description: 'Optional - trade at your own pace with no minimum requirements',
      icon: 'Calendar'
    },
    {
      id: 6,
      title: 'Leverage & Instruments',
      description: '1:1000 leverage on Synthetic Indices - 24/7 trading available',
      icon: 'Zap'
    }
  ]
};

export const howItWorks = [
  {
    step: 1,
    title: 'Choose Your Account',
    description: 'Select from Instant or 1 step account based on your trading style and capital needs',
    icon: 'Target'
  },
  {
    step: 2,
    title: 'Start Trading',
    description: 'Trade Deriv Synthetic Indices with institutional-grade risk management',
    icon: 'TrendingUp'
  },
  {
    step: 3,
    title: 'Meet Requirements',
    description: 'Follow our transparent rules and demonstrate consistent profitability',
    icon: 'CheckCircle2'
  },
  {
    step: 4,
    title: 'Withdraw Profits',
    description: 'Request payouts within 24-72 hours with your profit split',
    icon: 'Wallet'
  }
];

export const features = [
  {
    id: 1,
    title: 'Instant Funding',
    description: 'Get funded immediately after purchase. No evaluation challenges, start trading right away.',
    icon: 'Zap'
  },
  {
    id: 2,
    title: 'Fast Payouts',
    description: 'Withdraw your profits within 24-72 hours. Multiple payment methods supported.',
    icon: 'Wallet'
  },
  {
    id: 3,
    title: 'Transparent Rules',
    description: 'Clear, straightforward trading rules. No hidden conditions or surprise limitations.',
    icon: 'FileText'
  },
  {
    id: 4,
    title: 'Real-Time Dashboard',
    description: 'Track your performance with advanced analytics and risk metrics in real-time.',
    icon: 'BarChart3'
  },
  {
    id: 5,
    title: 'Institutional Risk Model',
    description: 'Professional risk management systems protecting both trader and firm.',
    icon: 'Shield'
  },
  {
    id: 6,
    title: '24/7 Support',
    description: 'Expert support team available around the clock to assist with any questions.',
    icon: 'MessageCircle'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Michael Chen',
    role: 'Professional Trader',
    content: 'The instant funding model changed everything for me. No more waiting through evaluation phases. Just pure trading.',
    avatar: 'MC',
    rating: 5
  },
  {
    id: 2,
    name: 'Sarah Williams',
    role: 'Full-Time Trader',
    content: 'Fast payouts and transparent rules. Finally, a prop firm that delivers what they promise.',
    avatar: 'SW',
    rating: 5
  },
  {
    id: 3,
    name: 'David Rodriguez',
    role: 'Algo Trader',
    content: 'The synthetic indices focus is perfect. 24/7 trading with consistent conditions. Highly recommended.',
    avatar: 'DR',
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: 'How does instant funding work?',
    answer: 'Once you purchase an account, you get immediate access to your funded account. No evaluation phase required. Start trading Deriv Synthetic Indices right away with our capital.'
  },
  {
    id: 2,
    question: 'What are Deriv Synthetic Indices?',
    answer: 'Synthetic indices are simulated markets that mimic real-world market movements. They are available 24/7, unaffected by natural events, and provide consistent volatility perfect for active trading.'
  },
  {
    id: 3,
    question: 'Can I Use Trading Bots and EAs?',
    answer: 'Yes! We fully support the use of trading bots, Expert Advisors (EAs), and automated trading strategies. You are free to use any trading automation tools on both our Instant Funded accounts and during the evaluation phase of our 1-Step accounts. There are no restrictions on algorithmic trading as long as you follow our risk management rules.'
  },
  {
    id: 4,
    question: 'What is the Profit Consistency Rule?',
    answer: `At the time of withdrawal, no single trading day may account for more than 25% of your total profit.

This rule ensures profits are earned through consistent trading rather than one unusually large trading day.

Example (Approved):
• Total profit: $4,000
• Highest single-day profit: $900 (22.5%)
✔ Withdrawal approved

Example (Not Approved):
• Total profit: $4,000
• Highest single-day profit: $1,500 (37.5%)
✖ Withdrawal declined until profits become more balanced

You may continue trading to distribute profits across multiple days and re-request withdrawal once the rule is met.

Note: This rule is only applicable to our "Instant Funded Accounts".`
  },
  {
    id: 5,
    question: 'How fast are payouts processed?',
    answer: 'Withdrawal requests are typically processed within 24-72 hours. We support multiple payment methods including bank transfer, crypto, and e-wallets.'
  },
  {
    id: 6,
    question: 'Can I scale my account?',
    answer: 'Yes! Demonstrate consistent profitability and risk management, and you can scale up to larger account sizes with better profit splits.'
  },
  {
    id: 7,
    question: 'What happens if I breach the rules?',
    answer: 'If you violate daily drawdown or maximum drawdown limits, the account will be terminated. However, you can purchase a new account anytime to restart.'
  }
];

export const stats = [
  {
    label: 'Funded Traders',
    value: 100,
    suffix: '+',
    prefix: ''
  },
  {
    label: 'Total Payouts',
    value: 8.5,
    suffix: 'k',
    prefix: '$'
  },
  {
    label: 'Success Rate',
    value: 73,
    suffix: '%',
    prefix: ''
  },
  {
    label: 'Max Capital',
    value: 50,
    suffix: 'K',
    prefix: '$'
  }
];

export const paymentMethods = [
  { name: 'Bank Transfer', processingTime: '24-48 hours' },
  { name: 'Cryptocurrency', processingTime: '12-24 hours' },
  { name: 'E-Wallets', processingTime: '24-72 hours' },
  { name: 'Wire Transfer', processingTime: '48-72 hours' }
];

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' }
];

// Dashboard mock data
export const dashboardData = {
  balance: 5000,
  equity: 5450,
  profit: 450,
  profitPercentage: 9.0,
  dailyDrawdown: 2.3,
  maxDrawdown: 4.5,
  tradingDays: 7,
  openPositions: 2,
  closedTrades: 23,
  winRate: 67.4,
  recentTrades: [
    { id: 1, symbol: 'Volatility 75 Index', profit: 125, time: '2 hours ago' },
    { id: 2, symbol: 'Volatility 100 Index', profit: -45, time: '5 hours ago' },
    { id: 3, symbol: 'Boom 1000 Index', profit: 230, time: '1 day ago' }
  ]
};